import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChange, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ClientSideListBaseComponent } from 'src/app/common/core/client-side-list-base/client-side-list-base.component';
import { PanelData } from 'src/app/common/interfaces/home/side-panel-details.interface';
import { columnDefinitionMDSignature } from './mdsignature.config';
import { ColDef } from 'ag-grid-community';
import { MDSection, Signaturedata } from 'src/app/common/interfaces/home/tasks.interface';
import { distinctUntilChanged, Subscription } from 'rxjs';
import { StorageService } from 'src/app/common/services/storage.service';
import { AppConstants } from 'src/app/common/constants/app-constants';
import {
  isReactDocumentationEnabled,
  reactDocumentationUrl,
} from 'src/app/common/utils/react-documentation-route.util';

@Component({
  selector: 'app-mdsignature',
  standalone: true,
  templateUrl: './mdsignature.component.html',
  styleUrls: ['./mdsignature.component.scss'],
  imports: [ClientSideListBaseComponent]
})
export class MDSignatureComponent implements OnInit, OnChanges, OnDestroy {
  columnDefinition!: ColDef[];
  @Input() rowData!: Signaturedata | undefined;
  pendingRecordsRowrowData!: MDSection[];
  rejectedRecordsRowData!: MDSection[];
  facilityId!: string;
  facilityIdSubscription!: Subscription;
  appConstants = AppConstants;

  constructor(private router: Router,
    private storageService: StorageService,
  ) {}

  ngOnInit(){
    this.columnDefinition = columnDefinitionMDSignature(this);
    this.updateRowData(this.rowData)
    this.facilityIdSubscription = this.storageService.isSelectedFacility
    .pipe(distinctUntilChanged())
    .subscribe((item) => {
      this.facilityId = item;
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['rowData'] && changes['rowData'].currentValue) {
      this.rowData = changes['rowData'].currentValue;
      this.updateRowData(this.rowData);
    }
  }

  updateRowData(rowData: Signaturedata | undefined) {
    if(rowData){
      this.pendingRecordsRowrowData = rowData['Documents Pending for Signature'];
      this.rejectedRecordsRowData = rowData['Documents Rejected for Signature'];
    }
  }

  navigate(row: PanelData) {
    if (isReactDocumentationEnabled() && row.patientId) {
      // The React app lives outside the Angular router.
      window.location.href = reactDocumentationUrl(
        this.facilityId,
        row.patientId,
        row.discipline,
      );
      return;
    }
    this.router.navigateByUrl(`/patient/${this.facilityId}/profile/${row.patientId}/document/${row.discipline}`);
  }
  
  ngOnDestroy(){
    this.facilityIdSubscription.unsubscribe();
  }

}
